import Settings from '_modules/settings/views/Settings.vue';

export default {
  path: 'settings',
  name: 'admin-settings',
  component: Settings,
};
